import React from 'react';

import GenericModal from '../../../components/agv-generic-modal';
import { MODAL_SIZE, MODAL_SIZE_STYLE } from '../../../enums/modal-size.enum';
import { Banner } from '../clients-ui';
import ClientChangesDiff from './client-changes-diff';

/**
 * Relecture obligatoire avant d'enregistrer une modification d'un client
 * existant : chaque champ modifié, avant / après. La modification est ensuite
 * tracée dans l'historique du client.
 */
export default function ClientChangesReviewModal({
  isOpen,
  setIsOpen,
  clientName,
  diff,
  onConfirm,
  isSaving,
}) {
  return (
    <GenericModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={`Vérifier les modifications — ${clientName}`}
      size={MODAL_SIZE_STYLE[MODAL_SIZE.XL]}
      secondaryActionText="Retour à la saisie"
      secondaryAction={() => setIsOpen(false)}
      mainActionText={`Enregistrer ${diff.length} modification${diff.length > 1 ? 's' : ''}`}
      mainAction={onConfirm}
      mainActionDisabled={!diff.length}
      mainActionIsLoading={isSaving}
    >
      <div className="tw-flex tw-flex-col tw-gap-3">
        <p className="tw-m-0 tw-text-sm">
          Vérifiez les modifications avant de les enregistrer. Elles seront
          tracées dans l’historique du client, avec votre nom.
        </p>
        <Banner tone="warn">
          Client en service : les options sont transmises dans le jeton de
          connexion, ses utilisateurs les verront à leur prochaine connexion.
        </Banner>
        <ClientChangesDiff diff={diff} />
      </div>
    </GenericModal>
  );
}
